import api from "./axios";

const authHeaders = (token) => ({
  headers: { Authorization: `Bearer ${token}` },
});

export const getSources = (token) => api.get("/source", authHeaders(token));
export const getSource = (id, token) => api.get(`/source/${id}`, authHeaders(token));
export const createSource = (data, token) =>api.post("/source/create", data, authHeaders(token));
export const updateSource = (id, data, token) => {
  return api.put(`/source/${id}`, data, authHeaders(token));
};
export const toggleSource = (id, isEnabled, token) => {
  return api.put(`/source/${id}/toggle`, { is_enabled: isEnabled }, authHeaders(token));
};
export const deleteSource = (ids, token) => api.post("/source/delete", { ids }, authHeaders(token));

